import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from 'core/icons';
import DisclaimerTarget from '../../common/notifications/DisclaimerTarget';
import { combineClassNames } from 'core/css';
import FeaturesCompareCell from './FeaturesCompareCell';
import BreakpointMatch from '../../common/mediaQuery/BreakpointMatch';

class Header extends React.Component {
  onClick = () => {
    const { feature, onToggleExpanded } = this.props;
    if (feature.details) {
      onToggleExpanded();
    }
  };

  render() {
    const { feature, analyticsKey, className, children } = this.props;
    const { description, disclosure, details } = feature;

    return (
      <div
        className={combineClassNames([className, 'stat-expand-icon'])}
        data-dtm={`${analyticsKey}:${description}`}
        onClick={this.onClick}>
        <div className="features-compare-feature-header">
          <DisclaimerTarget disclaimer={disclosure} stopPropagation={true}>
            <span dangerouslySetInnerHTML={{ __html: description }} />
          </DisclaimerTarget>
          {details && (
            <button>
              <SvgIcon
                name="info"
                className="features-compare-feature-header__icon"
              />
            </button>
          )}
        </div>
        {children}
      </div>
    );
  }
}

const ExpandedSection = props => {
  const { feature, isExpanded, analyticsKey, onToggle } = props;
  const {
    description,
    imageUrl,
    shortDescription,
    longDescription,
    disclaimer
  } = feature;

  if (!isExpanded) {
    return null;
  }

  return (
    <div className="features-compare-feature-expanded">
      <div
        className="features-compare-feature-expanded__close-row stat-image-link"
        data-dtm={`${analyticsKey}:${description}`}
        onClick={onToggle}>
        <SvgIcon
          name="close"
          className="features-compare-feature-expanded__close-icon"
        />
      </div>
      <div className="features-compare-feature-expanded__details">
        {imageUrl && (
          <div>
            <img
              alt={shortDescription}
              src={imageUrl}
              className="features-compare-feature-expanded__image"
            />
          </div>
        )}
        <div dangerouslySetInnerHTML={{ __html: longDescription }} />
        {disclaimer && <div dangerouslySetInnerHTML={{ __html: disclaimer }} />}
      </div>
    </div>
  );
};

const FeaturesCompareRowLarge = props => {
  const { feature, analyticsKey, isExpanded, onToggleExpanded } = props;

  return (
    <div className="features-compare-row">
      <Header
        feature={feature}
        analyticsKey={analyticsKey}
        className="features-compare-feature__row"
        onToggleExpanded={onToggleExpanded}>
        {feature.values.map((value, index) => (
          <FeaturesCompareCell
            key={index}
            value={value}
            className="features-compare-feature__column"
          />
        ))}
      </Header>
      <ExpandedSection
        feature={feature}
        analyticsKey={analyticsKey}
        isExpanded={isExpanded}
        onToggle={onToggleExpanded}
      />
    </div>
  );
};

const FeaturesCompareRowSmall = props => {
  const { feature, analyticsKey, isExpanded, onToggleExpanded } = props;

  return (
    <div className="features-compare-row">
      <Header
        feature={feature}
        analyticsKey={analyticsKey}
        onToggleExpanded={onToggleExpanded}
      />
      <ExpandedSection
        feature={feature}
        analyticsKey={analyticsKey}
        isExpanded={isExpanded}
        onToggle={onToggleExpanded}
      />
      <div className="features-compare-feature__row">
        {feature.values
          .slice(0, 2)
          .map((value, index) => (
            <FeaturesCompareCell
              key={index}
              value={value}
              className="features-compare-feature__column"
            />
          ))}
      </div>
    </div>
  );
};

class FeaturesCompareRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false
    };
  }

  onToggleExpanded = () => {
    this.setState(prevProps => ({
      isExpanded: !prevProps.isExpanded
    }));
  };

  render() {
    const { feature, analyticsKey } = this.props;
    const { isExpanded } = this.state;

    return (
      <BreakpointMatch
        breakpoint="large"
        render={isMatch => {
          const Child = isMatch
            ? FeaturesCompareRowLarge
            : FeaturesCompareRowSmall;
          return (
            <Child
              feature={feature}
              analyticsKey={analyticsKey}
              isExpanded={isExpanded}
              onToggleExpanded={this.onToggleExpanded}
            />
          );
        }}
      />
    );
  }
}

FeaturesCompareRow.propTypes = {
  feature: PropTypes.object.isRequired,
  analyticsKey: PropTypes.string
};

export default FeaturesCompareRow;
